import { COMPONENTS } from '../../../components/components.registry';
import { TermSuggestionsConfig } from '../../../models';

export const DEFAULT_TERM_SUGGESTIONS_CONFIG: TermSuggestionsConfig = {
  components: {
    container: COMPONENTS.PURE.Suggestions,
    header: null,
    item: COMPONENTS.PURE.TermSuggestion,
    icon: null
  },
  size: 10,
  showSameQuerySuggestion: false,
  showExtraSuggestionWithoutFacet: true
};
